export const RecentlyViewedEnum = {
  Location: {
    HOME: 'home',
    SHOP: 'shop',
    DEFAULT: 'default'
  } as const,
  TagType: {
    PREVIOUSLY_BOUGHT: 'previouslyBought',
    BEST_SELLER: 'bestSeller', 
    CUSTOM: 'custom'
  } as const,
  Defaults: {
    NUMBER_OF_DAYS: 14,
    MIN_PRODUCT_COUNT: 1,
    COUNT_OF_PRODUCTS_HP: 5,
    COUNT_OF_PRODUCTS_SP: 5,
  } as const,
} as const;

export type RecentlyViewedLocation = typeof RecentlyViewedEnum.Location[keyof typeof RecentlyViewedEnum.Location];
export type RecentlyViewedTagType = typeof RecentlyViewedEnum.TagType[keyof typeof RecentlyViewedEnum.TagType];

export interface RecentlyViewedItem {
  objectId: string;
  viewCount: number;
  lastViewedAt: Date;
  expiresAt: Date;
  user: any;
  product: any;
  isPreviouslyBought?: boolean;
  isActive?: boolean;
}

export interface RecentlyViewedConfig {
  numberOfDays: number;
  minProductCount: number;
  countOfProductsHP: number;
  countOfProductsSP: number;
  tags: { [productId: string]: string };
}

export interface RecentlyViewedData {
  items: RecentlyViewedItem[];
  shouldShowComponent: boolean;
  config: RecentlyViewedConfig | null;
}